import React from "react";
import AssignVendorBulkEdit from "./AssignVendorBulkEdit";

const AssignVendorFinanceBulkEdit = () => (
  <AssignVendorBulkEdit fixedVariant="finance" />
);

export default AssignVendorFinanceBulkEdit;
